"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Analytics_1 = tslib_1.__importDefault(require("../Analytics"));
var GTagEventObserver = /** @class */ (function () {
    function GTagEventObserver(conditions, action) {
        this.conditions = conditions;
        this.action = action;
    }
    GTagEventObserver.prototype.update = function (tracker, data) {
        if (this.conditions === false || data.type !== "event" || data.eventName === undefined) {
            return;
        }
        var conditions = this.conditions;
        var eventCategory = data.eventParams === undefined || data.eventParams.event_category === Analytics_1.default.emptyValue
            ? undefined
            : data.eventParams.event_category;
        var eventLabel = data.eventParams === undefined || data.eventParams.event_label === Analytics_1.default.emptyValue
            ? undefined
            : data.eventParams.event_category;
        var eventValue = data.eventParams === undefined
            ? undefined
            : data.eventParams.value;
        if (conditions === true
            || (conditions.eventAction(data.eventName)
                && (conditions.eventCategory === undefined || conditions.eventCategory(eventCategory))
                && (conditions.eventLabel === undefined || conditions.eventLabel(eventLabel))
                && (conditions.eventValue === undefined || conditions.eventValue(eventValue)))) {
            this.action(tracker, data);
        }
    };
    return GTagEventObserver;
}());
exports.default = GTagEventObserver;
